import { isObject } from 'underscore';

import { Speaker } from '@/types/speakers.types';
import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';
import Text from '@ui/text/text/text';
import Container from '@ui/container/container';

type TCastAndCrewOptionProps = {
  option: TReactSelectOption;
  isSelected: boolean;
};

const CastAndCrewOption = ({ option, isSelected }: TCastAndCrewOptionProps) => {
  if (!option) return null;
  if (!isObject(option)) return null;
  if (!('meta' in option)) return null;

  const speaker = option.meta as Speaker;
  return (
    <div className="flex ai-center jc-flex-center S3 height-36 padding-h-8 gap-8">
      {speaker.image ? (
        <Container
          className="square-22 radius-4"
          borderWidth="1px"
          borderColor={isSelected ? 'transparent' : 'var(--gray-1000)'}
          borderStyle="solid"
          outline={isSelected ? '2px solid var(--gray-100)' : '2px solid transparent'}
        >
          <img loading="lazy" className="radius-4 image-cover" width="100%" height="100%" src={speaker.image} />
        </Container>
      ) : (
        <Container background="var(--gray-700)" className="square-22 radius-4" />
      )}
      <Text tag="span" color="var(--gray-100)">
        {option.label}
      </Text>
    </div>
  );
};

export default CastAndCrewOption;
